<script lang="ts" context="module">
	import Tooltip from "./Tooltip.svelte";
</script>

<script lang="ts">
	export let title: string | undefined = undefined;
	export let url: string | URL | undefined = undefined;
	export let icon: "edit" | "group" | "person_add_alt_1" | undefined = undefined;
	export let iconOpacity: 1 | 0.5 = 1;
	export let iconResponsiveness: "alwaysShow" | "md" = "alwaysShow";
	export let chevron: "right" | undefined = undefined;
	export let chevronResponsiveness: "alwaysShow" | "md" = "alwaysShow";
	export let width: "full" | undefined = undefined;
	export let height: "sm" | "md" | "lg" = "md";
	export let style: "white" | "orange" | "blue" | "teal";
	export let textSize: "14" | "15" = "15";
	export let truncate: boolean = false;
	export let tooltip: string | undefined = undefined;

	let tag = url ? "a" : "button";
	const buttonProps: { href?: string } = {};
	if (url) {
		buttonProps.href = url.toString();
	}
</script>

<svelte:element
	this={tag}
	{...buttonProps}
	role="button"
	tabindex="0"
	on:click
	class="button-rounded flex transform items-center px-4 shadow-[0_2px_3px_rgba(0,0,0,0.08)] outline-none duration-100 ease-in-out active:translate-y-0.5 active:scale-[0.98]"
	class:w-full={width === "full"}
	class:text-nxgray-600={style === "white"}
	class:bg-white={style === "white"}
	class:hover:bg-gray-100={style === "white"}
	class:focus:bg-gray-100={style === "white"}
	class:border={style === "white"}
	class:border-gray-500={style === "white"}
	class:hover:border-gray-600={style === "white"}
	class:focus:border-gray-600={style === "white"}
	class:text-white={style === "orange" || style === "blue" || style === "teal"}
	class:bg-orange-600={style === "orange"}
	class:hover:bg-orange-500={style === "orange"}
	class:focus:bg-orange-500={style === "orange"}
	class:bg-blue-600={style === "blue"}
	class:hover:bg-blue-500={style === "blue"}
	class:focus:bg-blue-500={style === "blue"}
	class:bg-teal-600={style === "teal"}
	class:hover:bg-teal-500={style === "teal"}
	class:focus:bg-teal-500={style === "teal"}
	class:py-1.5={height === "sm"}
	class:py-2.5={height === "md"}
	class:py-4={height === "lg"}
	class:justify-center={!chevron}
	class:justify-between={chevron}
	class:md:pr-2={chevron && chevronResponsiveness === "md"}
	class:md:pl-3={chevron && chevronResponsiveness === "md"}>
	<slot>
		<div class="flex items-center">
			{#if icon}
				<span
					class="material-icons button-icon mr-1.5 hidden text-18 text-white"
					class:opacity-50={iconOpacity == 0.5}
					class:block={iconResponsiveness === "alwaysShow"}
					class:md:block={iconResponsiveness === "md"}>
					{icon}
				</span>
			{/if}
			<span class="font-medium leading-tight" class:truncate class:text-14={textSize === "14"} class:text-15={textSize === "15"}>
				<slot name="title">
					{title}
				</slot>
			</span>
		</div>
	</slot>
	{#if chevron === "right"}
		<div
			class="material-icons hidden text-20 font-medium opacity-50"
			class:block={chevronResponsiveness === "alwaysShow"}
			class:md:block={chevronResponsiveness === "md"}>
			chevron_right
		</div>
	{/if}

	{#if tooltip}
		<Tooltip>
			<span class="text-13">{tooltip}</span>
		</Tooltip>
	{/if}
</svelte:element>

<style>
	.button-rounded {
		border-radius: var(--button--rounded);
	}
</style>
